import { FileText, Download } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Document {
  id: number;
  document_name: string;
  file_name: string;
  file_path: string;
}

interface DocumentsListProps {
  documents: Document[];
}

export const DocumentsList = ({ documents = [] }: DocumentsListProps) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 h-full">
      <h2 className="text-xs font-bold text-slate-800 tracking-wide uppercase mb-4">Documents</h2>
      
      {documents.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <FileText size={32} className="mx-auto mb-3 opacity-20" />
          <p className="text-sm">No documents available</p>
        </div>
      ) : (
        <div className="space-y-3">
          {documents.map((doc) => (
            <div key={doc.id} className="flex items-center justify-start gap-4 p-2.5 bg-slate-50 border border-gray-100 rounded-lg">
              <div className="flex items-center gap-3 w-[200px] shrink-0">
                <div className="bg-blue-100 text-blue-700 p-1.5 rounded">
                  <FileText size={16} />
                </div>
                <div>
                  <p className="font-bold text-sm text-gray-900 truncate">{doc.document_name}</p>
                  <p className="text-[10px] text-gray-500 truncate">{doc.file_name}</p>
                </div>
              </div>
              
              <Button 
                variant="outline" 
                size="sm" 
                className="text-blue-700 border-blue-200 hover:bg-blue-50 font-semibold h-8 text-xs shrink-0"
                onClick={() => window.open(`/api${doc.file_path}`, '_blank')}
              >
                <Download className="mr-1.5 h-3.5 w-3.5" /> Download
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
